import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  color: #212530;
  font-family: "MaisonNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.75px;
  text-align: left;
  padding: 16px;
  border-bottom: 1px solid #ebebeb;
  background-color: #ffffff;
  border: 1px solid #ebeafb;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
`;

export const ClientName = styled.div`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.13px;
  margin-bottom: 4px;
`;

export const FeedNameAndType = styled.div`
  color: #52555d;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.43px;

  svg {
    margin-left: 4px;
    margin-right: 4px;
  }
`;

export const CloseButtonContainer = styled.div`
  width: 16px;
  height: 16px;

  svg {
    cursor: pointer;
  }

  path {
    fill: #797b81;
  }
`;
